import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi, type CreateInvitePayload } from '@entities/admin';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useInviteAdmin() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (body: CreateInvitePayload) => adminApi.invite(body),
    onSuccess: () => {
      toast.success('Приглашение отправлено');
      void qc.invalidateQueries({ queryKey: ['admin-invites'] });
    },
    onError: (e: Error) => toast.error('Не удалось пригласить', e.message),
  });
}

export function useRevokeInvite() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (id: UUID) => adminApi.revokeInvite(id),
    onSuccess: () => {
      toast.success('Приглашение отозвано');
      void qc.invalidateQueries({ queryKey: ['admin-invites'] });
    },
    onError: (e: Error) => toast.error('Не удалось отозвать', e.message),
  });
}

export function useRevokeAdmin() {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (id: UUID) => adminApi.revokeAdmin(id),
    onSuccess: () => {
      toast.success('Роль ADMIN снята');
      void qc.invalidateQueries({ queryKey: ['admins'] });
    },
    onError: (e: Error) => toast.error('Не удалось снять роль', e.message),
  });
}
